<div class="it-contextbar" [class.is-missing]="!vm.selectedIntegrationId || !vm.selectedLoginId">
	<div class="it-context-fields it-context-fields-primary">
		<div class="it-context-field">
			<div class="it-context-label">Integration</div>
			<dx-select-box class="it-control it-context-control" [dataSource]="vm.integrations" displayExpr="name" valueExpr="id" [value]="vm.selectedIntegrationId" (onValueChanged)="onIntegrationChanged($event)">
			</dx-select-box>
		</div>

		<div class="it-context-field">
			<div class="it-context-label">Login</div>
			<dx-select-box class="it-control it-context-control" [dataSource]="vm.logins" displayExpr="description" valueExpr="id" [value]="vm.selectedLoginId" [disabled]="!vm.selectedIntegrationId" (onValueChanged)="onLoginChanged($event)">
			</dx-select-box>
		</div>

		<div class="it-context-field it-context-actions">
			<div class="it-context-label">Test login</div>
			<button type="button" class="it-toolbtn it-toolbtn-primary" [disabled]="!vm.selectedIntegrationId || !vm.selectedLoginId || vm.isSending || vm.isTestingLogin" (click)="testLogin.emit()">
        {{ vm.isTestingLogin ? 'Testing...' : 'Test login' }}
      </button>
		</div>
	</div>
</div>
